var map = {
	"./config-builder.js": "./src/helpers/config-builder.js",
	"./data-source.js": "./src/helpers/data-source.js",
	"./document-type.js": "./src/helpers/document-type.js",
	"./importer.js": "./src/helpers/importer.js",
	"./project-type.js": "./src/helpers/project-type.js",
	"./transformer.js": "./src/helpers/transformer.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 101;



//////////////////
// WEBPACK FOOTER
// ./src/helpers nonrecursive ((?!spec).{4}|^.{0,3})\.js$
// module id = 101
// module chunks = 0